import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:managePromotionCodeList
 * @description
 * # managePromotionCodeList
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'managePromotionCodeList',
    ($ngRedux, $rootScope, $scope, $location, $route, $http, ENV) => {
      if (!$scope.isSuperUser) {
        $location.path('/');
      }

      $scope.processParams = () =>
        new Promise((resolve) => {
          const { promoCodeId } = $route.current.params;
          $scope.takeAction(promoCodeId);
          resolve(true);
        });

      $scope.takeAction = (id) => {
        if (!id) return;

        if (id === 'create-promotion-code') {
          $scope.open(id);
        } else if (id) {
          $scope
            .getPromotionCode($http, ENV, id)
            .then(() => {
              $scope.open(id);
            })
            .catch(() => {
              const errorModalOptions = {
                heading: 'Promotion Code Error',
                message: `${id} is not available at this time.  It either does not exist or has caused an error.  Please try again later or contact support if the error persists.`,
                buttons: [
                  {
                    label: 'Close',
                    href: '#',
                    clickFn: () => {
                      $rootScope.toggleErrorModal();
                      $location.path($rootScope.routes['promotion-code'], false);
                    },
                  },
                ],
              };
              $rootScope.toggleErrorModal(errorModalOptions);
            });
        }
      };

      $scope.open = (id) => {
        const component =
          id === 'create-promotion-code' ? 'create-promotion-code' : 'edit-promotion-code';
        const closeRoute = $rootScope.previousRoute || $rootScope.routes['promotion-code'];
        const beforeRoute = `${$rootScope.routes['promotion-code']}/${id}`;
        $rootScope.openComponent({
          component: component,
          beforeRoute: beforeRoute,
          closeRoute: closeRoute,
        });
      };

      $scope.init = () => {
        $rootScope.previousRoute = $rootScope.routes['promotion-code'];
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
        $scope.processParams();
      };

      $scope.table = {
        name: 'Manage Promotion Codes',
        options: {
          endpoint: '/2.0/promotion-codes/',
          endpoint_data_key: 'promotion-codes',
          per_page_options: [5, 15, 25, 50, 100, 200],
          records_per_page: 5,
          row_style: 'standard',
          scale_up: false,
          search_key: 'Promotion Codes',
          search_required: false,
        },
        actions: [
          {
            name: 'Create Promotion Code',
            link: '#',
            onclick: () => {
              $scope.takeAction('create-promotion-code');
            },
            order: 0,
            superuser: true,
          },
        ],
        columns: [
          {
            name: 'Code',
            options: {
              content: '<span style="text-transform: uppercase;">{{ record.code }}</span>',
              class: '',
            },
          },
          {
            name: 'Type',
            options: {
              content: '{{ record.type.name }}',
              class: '',
            },
          },
          {
            name: 'Brands/Products/Organizations',
            options: {
              content:
                '<div ng-if="record.type.slug !== \'invoice_code\' || (record.brands.length === 0 && record.products.length === 0 && record.organizations.length === 0)" style="text-align:center;">n/a</div>' +
                '<div ng-if="record.type.slug === \'invoice_code\' && record.brands.length > 0" class="promotion-code-brands"><span class="bold">Brands:</span><span ng-if="record.brands_rule" class="bold italic">Brand Rule:</span> ' +
                '<span ng-if="record.brands_rule">{{ record.brands_rule }} </span>' +
                '<ul><li ng-repeat="brand in record.brands|limitTo:2">{{ brand.brand.name }}<span ng-if="brand.min_doses"> - Min Doses: {{ brand.min_doses }}</span></li><li class="italic" ng-if="record.brands.length > 2"><a href="#" ng-click="takeAction(record.id)">additional brands not listed here</a></li></ul></div>' +
                '<div ng-if="record.type.slug === \'invoice_code\' && record.products.length > 0" class="promotion-code-products"><span class="bold">Products:</span><span ng-if="record.skus_rule" class="bold italic">Product Rule:</span> ' +
                '<span ng-if="record.skus_rule">{{ record.skus_rule }} </span>' +
                '<ul><li ng-repeat="product in record.products|limitTo:2"><span ng-if="product.product.dosage_label">{{ product.product.dosage_label }}</span>' +
                '<span ng-if="product.product.package_label"> ({{ product.product.package_label }})</span><span class="sku"> SKU: {{ product.product.sku }}</span> <span ng-if="product.min_doses">- Min Doses: {{ product.min_doses }}</span></li><li class="italic" ng-if="record.products.length > 2"><a href="#" ng-click="takeAction(record.id)">additional products not listed here</a></li></ul></div>' +
                '<div ng-if="record.type.slug === \'invoice_code\' && record.organizations.length > 0" class="promotion-code-organizations"><span class="bold">Organizations:</span><ul><li ng-repeat="organization in record.organizations|limitTo:2">{{ organization.name }}</li><li class="italic" ng-if="record.organizations.length > 2"><a href="#" ng-click="takeAction(record.id)">additional organizations not listed here</a></li></ul></div>',
              class: 'promotion-code-list',
            },
          },
          {
            name: 'Frequency/Purchase Limits',
            options: {
              content:
                '<div ng-if="record.type.slug !== \'invoice_code\'" style="text-align:center;">n/a</div>' +
                '<div ng-if="record.type.slug === \'invoice_code\'" class="promotion-code-frequency-limits"><span class="bold">Frequency Limits:</span><ul><li>User: {{ record.frequency_cap_user }}</li><li>Pet: {{ record.frequency_cap_pet }}</li><li>Pet and Brand: {{ record.frequency_cap_pet_and_brand }}</li></ul></div>' +
                '<div ng-if="record.type.slug === \'invoice_code\' && (record.first_time_purchase_user || record.first_time_purchase_pet || record.first_time_purchase_clinic)" class="promotion-code-purchase-limits"><span class="bold">Purchase Limits:</span><ul><li ng-if="record.first_time_purchase_user">First Time Purchase User</li><li ng-if="record.first_time_purchase_pet">First Time Purchase Pet</li><li ng-if="record.first_time_purchase_clinic">First Time Purchase Clinic</li></ul></div>',
              class: 'promotion-code-list',
            },
          },
          {
            name: 'Points Calculation',
            options: {
              content:
                '<div ng-if="record.point_data.num_points" class="promotion-code-num-points"><span class="bold">Number of Points: </span><br/><ul ng-if="record.point_data.num_points"><li ng-repeat="(key, value) in record.point_data.num_points track by $index">{{ key | capitalize }}: {{ value }}</li></ul></div>' +
                '<div ng-if="record.point_data.point_multiplier" class="promotion-code-points-multiplier"><span class="bold">Point Multiplier: </span><br/><ul ng-if="record.point_data.point_multiplier"><li ng-repeat="(key, value) in record.point_data.point_multiplier track by $index">{{ key | capitalize }}: {{ value }}</li></ul></div>',
              class: 'promotion-code-list',
            },
          },
          {
            name: 'Action',
            options: {
              content: '<a href="#" ng-click="takeAction(record.id)">Edit Promotion Code</a>',
              class: 'td-action',
            },
          },
        ],
        filters: [
          {
            name: 'Promotion Code Type',
            type: 'multiple_choice',
            options: {
              choices: {},
              choices_endpoint: '/2.0/promotion-codes/types/?order=name',
              choices_endpoint_data_key: 'promotion-code-types',
              class: 'application-filter',
              name_attribute: 'name',
              query_string_parameter: 'type_id',
            },
          },
          {
            name: 'Promotion Code Status',
            type: 'multiple_choice',
            options: {
              choices: {
                Active: { state: true, value: 'enabled', order: 0 },
                Inactive: { state: true, value: 'disabled', order: 1 },
              },
              class: 'application-filter',
              query_string_parameter: 'status',
            },
          },
        ],
        sort_options: {
          created: {
            state: true,
            value: '-1',
            title: 'Promotion Code Created',
            order: 0,
          },
          updated: {
            state: false,
            value: '-1',
            title: 'Promotion Code Updated',
            order: 1,
          },
          code: {
            state: false,
            value: '1',
            title: 'Promotion Code',
            order: 2,
          },
          type__slug: {
            state: false,
            value: '1',
            title: 'Promotion Code Type',
            order: 3,
          },
        },
      };

      $scope.init();

      $scope.$on('$destroy', $scope.unsubscribe);
    },
  );
